import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AppFeatures } from '@cp/schemas';
import { authFetch } from '../auth/auth-fetch.js';

export type { AppFeatures } from '@cp/schemas';

/**
 * `GET /features` — deployment-level switches the SPA shapes its own gates
 * on (today: the media compliance mode, see `docs/configuration.md`). One
 * shared key so every reader hits one cache; a value that changes only with
 * a redeploy needs no refetch on focus.
 */
export const APP_FEATURES_QUERY_KEY = ['app-features'] as const;

export async function fetchAppFeatures(): Promise<AppFeatures> {
  const res = await authFetch('/features');
  if (!res.ok) throw new Error('failed to load features');
  return (await res.json()) as AppFeatures;
}

/**
 * Callers treat `data === undefined` (loading, or the request failed) as
 * `enforce`: the gate's safe side, never the open one — see
 * `ImageBlock` in `features/posts/editor-drawer-image.tsx`.
 */
export function useAppFeatures(): UseQueryResult<AppFeatures> {
  return useQuery({
    queryKey: APP_FEATURES_QUERY_KEY,
    queryFn: fetchAppFeatures,
    staleTime: 5 * 60_000,
  });
}
